import React, { useEffect, useRef, useState } from 'react'
import { Box, Button, Grid, makeStyles, Typography, useMediaQuery, useTheme } from '@material-ui/core'
import axios from 'axios'
import HeaderImage from '../partials/HeaderImage'
import FortuneWheel from './FortuleWheel'
import LuckyWheel from './LuckyWheel'
import Question from '../../components/Question'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import parse from 'html-react-parser'
import Terms from '../partials/Terms'
import { bannedWords, dateRegex, phoneNumberRegex, postCodeRegex } from '../InputValidation.const'
import { getValidateEmail } from '../../../api'
import ReactGA from 'react-ga'
import validator from 'validator'
import queryString from 'query-string'

const useStyles = makeStyles(theme => ({
    root: {
        [theme.breakpoints.down('xs')]: {}
    },
    title: {
        lineHeight: 1.1,
        [theme.breakpoints.up('sm')]: {
            fontSize: '1.7rem!important',
            marginBottom: theme.spacing(1.25),
            marginTop: theme.spacing(1.5) + 'px!important'
        },
        marginTop: theme.spacing(1) + 'px!important',
        marginBottom: theme.spacing(0.75),
        '& span': {
            fontWeight: 400
        }
    },
    longTitle: {
        [theme.breakpoints.up('sm')]: {
            padding: '0 50px!important'
        }
    },
    description: {
        textAlign: 'center!important',
        lineHeight: 1.25,
        paddingBottom: theme.spacing(0.25)
    },
    submitButton: {
        color: 'white'
    },
    wheelContainer: {
        //backgroundImage: 'linear-gradient(360deg, #4158D0 0%, #C850C0 20%, #C850C0 60%, #FFCC70 90%, #f9f9f9 100%)', //Deeper colors
        //backgroundImage: 'linear-gradient(360deg, #91a2ff 0%, #cf63c8 20%, #e28add 60%, #fffe97 90%, #f9f9f9 100%)',
        backgroundImage: 'linear-gradient(360deg, #91acff 0%, #8dd2f5 20%, #c5e3ff 60%, #ddf8ff 90%, #f9f9f9 100%)',
        paddingTop: 78,
        marginTop: -60,
        paddingLeft: 4,
        paddingRight: 4
    },
    disclaimer: {
        color: 'white!important',
        textAlign: 'center',
        lineHeight: 1.4
    }
}))

const prizes = [
    {
        id: 'new_round',
        text: 'Pyöritä uudelleen 1'
    },
    {
        id: 'small_priz',
        text: 'Lohdutuspalkinto 1'
    },
    {
        id: 'jackpot',
        text: 'PÄÄVOITTO!!'
    },
    {
        id: 'no_priz',
        text: 'Ei voittoa 1'
    },
    {
        id: 'new_round2',
        text: 'Pyöritä uudelleen 2'
    },
    {
        id: 'no_priz2',
        text: 'Ei voittoa 2'
    },
    {
        id: 'small_priz3',
        text: 'Ei voittoa 3'
    },
    {
        id: 'no_priz3',
        text: 'Ei voittoa 4'
    }
]
const oneFullRotationTime = 1000
const extraRotationCount = 2

let fortuneWheelActive = true

const firstPageQuestionIds = [7, 8, 9]
const secondPageQuestionIds = [11, 12, 13, 14, 15, 48]

function SignupView({ questionPage, visitorSessionId, theme, onComplete }) {
    const classes = useStyles()
    const muiTheme = useTheme()
    const isMobileDevice = useMediaQuery(muiTheme.breakpoints.down('sm'))
    const [isLoading, setIsLoading] = useState(true)
    const [questionValues, setQuestionValues] = useState([])
    const [render, setRender] = useState(0)
    const [step, setStep] = useState(0)
    const [isSpinning, setIsSpinning] = useState(false)
    const luckyWheel = useRef(null)
    const [price, setPrice] = useState(null)
    const [priceValue, setPriceValue] = useState(0)
    const [isValidEmail, setIsValidEmail] = useState(false)
    const [emailValidationOneInvalid, setEmailValidationOneInvalid] = useState(false)
    const initialRender = useRef(true)

    const onQuestionValueChanged = (id, value, validate = true) => {
        let newQuestionValues = questionValues
        let questionIndex = newQuestionValues.findIndex(x => x.id === id)
        if (questionIndex < 0) {
            const questionValue = { id: id, value: value }
            newQuestionValues.push(questionValue)
        } else {
            newQuestionValues[questionIndex].value = value
        }
        setQuestionValues(newQuestionValues)
        setRender(render => render + 1)
    }

    useEffect(() => {
        setQueryStringAnswers()
    }, [step])

    useEffect(() => {
        if (initialRender.current) {
            initialRender.current = false
            return
        }
        submit()
    }, [isValidEmail])

    const submit = () => {
        const isAnswersValid = validateAnswers(true)
        if (!isAnswersValid) {
            setRender(render => render + 1)
            return
        }

        if (step === 0) {
            spin()
            setIsLoading(true)
            axios
                .post(process.env.MIX_API_URL + '/aq/answer', { visitor_session_id: visitorSessionId, answers: questionValues })
                .then(({ data, ...res }) => {
                    setIsLoading(false)
                })
                .catch(error => {
                    console.log('error on answer', error)
                })
        }
        if (step === 1) {
            finishSignup()
        }
    }

    const spin = () => {
        ReactGA.event({
            category: 'FortuneWheel',
            action: 'Spin'
        })

        setIsSpinning(true)
        luckyWheel?.current?.spin()
    }

    const finishSignup = () => {
        const filteredQuestionValues = questionValues.filter(value => secondPageQuestionIds.includes(value.id))
        onComplete(filteredQuestionValues)
    }

    const handleSpinComplete = price => {
        setIsSpinning(false)
        setPrice(price)
        if (price.priceValue > 0) {
            setPriceValue(priceValue => priceValue + price.priceValue)
        }
        setStep(step => step + 1)
        if (isMobileDevice) {
            scrollToStart()
        }
    }

    const getTitle = () => {
        if (step === 0) {
            return 'Pyöräytä pyörää ja osallistu arvontaan! <span>🎉</span>'
        }
        if (step === 1) {
            return 'Onnea! <span>🎉</span> Arvonnan palkintosi suuruus on huikea 1000€!'
        }

        /*if (price?.priceStr) {
            return price.priceStr.replace('{priceValue}', priceValue)
        }*/
    }

    const getDescription = () => {
        if (step === 0) {
            return 'Kerro, mihin osoitteeseen haluat tiedon voitostasi ja pyöräytä pyörää!'
        }
        if (step === 1) {
            return 'Syötä vielä yhteystietosi, niin olet mukana arvonnassa.'
        }
    }

    const setQueryStringAnswers = () => {
        const parsedQueryString = queryString.parse(window.location.search)
        const elements = getElements()
        for (let question of elements) {
            if (question.value) {
                onQuestionValueChanged(question.id, question.value)
            } else if (parsedQueryString && parsedQueryString[question.name]) {
                const value =
                    question.type === 'text' || question.type === 'email' || question.type === 'date'
                        ? parsedQueryString[question.name]
                        : question.options.find(option => option.label === parsedQueryString[question.name])?.id
                onQuestionValueChanged(question.id, value)
            }
        }
    }

    const getElements = () => {
        return step === 0
            ? questionPage.elements.filter(el => firstPageQuestionIds.includes(el.id))
            : questionPage.elements.filter(el => secondPageQuestionIds.includes(el.id))
    }

    const getButtonLabel = () => {
        if (step === 0) {
            return 'Pyöräytä pyörää!'
        }
        if (step === 1) {
            return 'Osallistu arvontaan!'
        }
    }

    const scrollToStart = () => {
        const element = document.getElementById('questionApplication')
        if (!isElementInView(element)) {
            element.scrollIntoView({ behavior: 'smooth' })
        }
    }

    const isElementInView = element => {
        const bounding = element.getBoundingClientRect()
        return (
            bounding.top >= 0 &&
            bounding.left >= 0 &&
            bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
        )
    }

    const validateAnswers = onSubmit => {
        let valid = true
        const questions = getElements()?.filter(x => x.elementType === 'question')
        for (let question of questions) {
            let errorMessage = isAnswerValid(question, onSubmit)
            if (errorMessage !== null) {
                if (errorMessage === 'waiting') {
                    valid = false
                    question.valid = false
                    question.errorMessage = ''
                    question.waitingValidation = true
                } else {
                    valid = false
                    question.valid = false
                    question.errorMessage = errorMessage
                }
            } else {
                question.valid = true
            }
        }
        return valid
    }

    const isAnswerValid = (question, onSubmit) => {
        const validationStr = question.validation
        if (!validationStr) {
            return null
        }
        const validationArr = validationStr.split('|')
        const answer = questionValues.find(x => x.id === question.id)
        for (let validationType of validationArr) {
            if (validationType === 'required') {
                if (!answer || !answer.value) {
                    if (process.env.MIX_APP_COUNTRY === 'denmark') {
                        return 'Svar på dette igen'
                    }
                    if (process.env.MIX_APP_COUNTRY === 'sweden') {
                        return 'Svara på detta'
                    }
                    return 'Vastaa vielä tähän'
                }
            }
            if (validationType.substring(0, 5) === 'size:') {
                let value = parseInt(validationType.substring(5))
                if (!answer || answer.value.length < value) {
                    if (process.env.MIX_APP_COUNTRY === 'denmark') {
                        return 'Tjek det her'
                    }
                    if (process.env.MIX_APP_COUNTRY === 'sweden') {
                        return 'Ogiltigt'
                    }
                    return 'Vastaus on liian lyhyt'
                }
            }
            if (validationType === 'noBannedWords') {
                for (let bannedWord of bannedWords) {
                    if (!answer || answer.value.toLowerCase().indexOf(bannedWord) !== -1) {
                        if (process.env.MIX_APP_COUNTRY === 'denmark') {
                            return 'Tjek det her'
                        }
                        if (process.env.MIX_APP_COUNTRY === 'sweden') {
                            return 'Ogiltigt'
                        }
                        return 'Vastaus ei ole kelvollinen'
                    }
                }
            }
            if (validationType === 'email') {
                if (!answer || !validator.isEmail(answer.value)) {
                    if (process.env.MIX_APP_COUNTRY === 'denmark') {
                        return 'Tjek det her'
                    }
                    if (process.env.MIX_APP_COUNTRY === 'sweden') {
                        return 'Ogiltigt'
                    }
                    return 'Sähköpostiosoite ei ole kelvollinen'
                } else if (validator.isEmail(answer.value)) {
                    if (!isValidEmail && onSubmit) {
                        onValidateEmail(question, answer.value)
                        return 'waiting'
                    }
                }
            }
            if (validationType === 'date') {
                if (!answer || !dateRegex.test(answer.value)) {
                    if (process.env.MIX_APP_COUNTRY === 'denmark') {
                        return 'Tjek det her'
                    }
                    if (process.env.MIX_APP_COUNTRY === 'sweden') {
                        return 'Ogiltigt'
                    }
                    return 'Päivämäärä ei kelpaa'
                }
            }
            if (validationType === 'phonenumber') {
                let phoneNumberRegexResult = phoneNumberRegex.test(answer.value)
                if (!answer || !phoneNumberRegexResult) {
                    if (process.env.MIX_APP_COUNTRY === 'denmark') {
                        return 'Tjek det her'
                    }
                    if (process.env.MIX_APP_COUNTRY === 'sweden') {
                        return 'Ogiltigt'
                    }
                    return 'Puhelinnumero ei kelpaa'
                }
            }
            if (validationType === 'postcode') {
                if (!answer || !postCodeRegex.test(answer.value)) {
                    if (process.env.MIX_APP_COUNTRY === 'denmark') {
                        return 'Tjek det her'
                    }
                    if (process.env.MIX_APP_COUNTRY === 'sweden') {
                        return 'Ogiltigt'
                    }
                    return 'Postinumero ei kelpaa'
                }
            }
            if (validationType === 'y-tunnus') {
                if (!answer || answer.value.length !== 9) {
                    return 'Väärän pituinen Y-tunnus'
                }
                const yTunnus = answer.value
                const yTunnusSum =
                    7 * yTunnus[0] + 9 * yTunnus[1] + 10 * yTunnus[2] + 5 * yTunnus[3] + 8 * yTunnus[4] + 4 * yTunnus[5] + 2 * yTunnus[6]
                const yTunnusMod = yTunnusSum % 11
                const yTunnusCheckSum = yTunnusMod === 0 ? 0 : 11 - yTunnusMod

                if (Number(yTunnusCheckSum) !== Number(yTunnus[8])) {
                    return 'Viallinen Y-tunnus'
                }
            }
        }
        return null
    }

    const onValidateEmail = (question, email) => {
        getValidateEmail(email).then(data => {
            if (data.error === true) {
                ReactGA.event({
                    category: 'EmailValidation',
                    action: 'Error'
                })
                setEmailValidated(question)
            } else {
                const sendex = data.sendex
                if (sendex >= 0.7) {
                    ReactGA.event({
                        category: 'EmailValidation',
                        action: 'Confirmed'
                    })
                    console.log('EmailValidation Confirmed')
                    setEmailValidated(question)
                } else if (emailValidationOneInvalid === true) {
                    ReactGA.event({
                        category: 'EmailValidation',
                        action: 'LetThroughAfterOneInvalid'
                    })
                    setEmailValidated(question)
                } else {
                    ReactGA.event({
                        category: 'EmailValidation',
                        action: 'Not Confirmed'
                    })
                    const confirmationDialog = {
                        open: true,
                        title: 'Varmista sähköpostiosoitteesi',
                        description:
                            'Huomasimme, että sähköpostiosoitteesi <b>' +
                            email +
                            '</b> saattaa olla virheellinen. Vahvistathan osoitteesi tai käytä toista sähköpostiosoitetta.'
                    }
                    /*this.setState({
                        confirmationDialog: confirmationDialog,
                        confirmAnswerValue: '',
                        questionInConfirmation: question,
                        emailValidationOneInvalid: true
                    })*/
                }
            }
        })
    }

    const setEmailValidated = question => {
        question.waitingValidation = false
        setIsValidEmail(true)
    }

    return (
        <Box>
            {theme?.headerImage && <HeaderImage theme={theme} questionPage={questionPage} />}
            <Box>
                <Typography variant="h4" component="h4" align="center" className={classes.title + ' ' + (step === 1 ? classes.longTitle : '')}>
                    {parse(getTitle() ?? '')}
                </Typography>
                <Typography variant="body1" color="textSecondary" className={classes.description}>
                    {getDescription()}
                </Typography>
            </Box>
            <Box mt={{ xs: step === 1 ? 1 : 2, sm: 2 }} mb={2.5}>
                <Grid container spacing={2} item>
                    {getElements().map((element, key) => {
                        const questionValue = questionValues.find(x => x.id === element.id)
                        const value = questionValue ? questionValue.value : null

                        return (
                            <React.Fragment key={key}>
                                {element.elementType === 'question' && (
                                    <Question
                                        question={element}
                                        value={value}
                                        onValueChanged={onQuestionValueChanged}
                                        visitorSessionId={visitorSessionId}
                                        theme={theme}
                                    />
                                )}
                            </React.Fragment>
                        )
                    })}
                </Grid>
            </Box>
            <Box>
                <Button
                    fullWidth
                    onClick={submit}
                    color="primary"
                    variant="contained"
                    size={'large'}
                    endIcon={<FontAwesomeIcon size="lg" icon={['far', 'shield-check']} />}
                    className={classes.submitButton}
                    disabled={isSpinning}
                >
                    {getButtonLabel()}
                </Button>
            </Box>
            <Box mx={{ xs: -2, sm: -4 }} mb={{ xs: -1 }} className={classes.wheelContainer}>
                <LuckyWheel ref={luckyWheel} onComplete={handleSpinComplete} size={step === 1 ? 'small' : 'default'} />
                {step === 0 && (
                    <Box align={'center'} px={1} pb={1}>
                        <Typography component="div" variant="overline" className={classes.disclaimer}>
                            Vain yksi osallistuminen per käyttäjä. Palkintoja on rajallinen määrä.
                        </Typography>
                        <Box mx={{ xs: 1, sm: 2 }}>
                            <Terms domain={questionPage.domain} paddingTop={4} />
                        </Box>
                    </Box>
                )}
            </Box>
            {false && (
                <FortuneWheel
                    active={fortuneWheelActive}
                    prizes={prizes}
                    oneFullRotationTime={oneFullRotationTime}
                    extraRotationCount={extraRotationCount}
                    onSelection={handleSpinComplete}
                />
            )}
        </Box>
    )
}

export default SignupView
